import { styled } from "@mui/material/styles";
import { Box, Button, Typography } from "@mui/material";

export const RootContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
}));

export const ModalContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "stretch",
  backgroundColor: theme.palette.background.default,
  borderRadius: "10px",
  position: "relative",
  padding: "48px 42px 36px 42px",
  border: `1px solid ${theme.palette.background.paper}`,
  width: "960px",
  minHeight: "420px",
  boxSizing: "border-box",
  [theme.breakpoints.down("lg")]: {
    width: "88vw",
    padding: "32px 24px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "92vw",
    padding: "24px 16px",
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  textAlign: "left",
  fontSize: "32px",
  fontWeight: 700,
  lineHeight: 1.2,
  marginBottom: "36px",
  color: theme.palette.text.primary,
  [theme.breakpoints.down("md")]: {
    textAlign: "left",
    fontSize: "28px",
    marginBottom: "28px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "24px",
  },
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch",
  justifyContent: "space-between",
  gap: "28px",
  marginBottom: "24px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: "20px",
  },
}));

export const UploadButtonsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  width: "46%",
  justifyContent: "center",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

export const UploadButton = styled(Button)(({ theme }) => ({
  width: "46%",
  minHeight: "148px",
  border: `2px dashed ${theme.palette.primary.main}`,
  color: theme.palette.text.primary,
  backgroundColor: "transparent",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textTransform: "none",
  padding: "24px",
  borderRadius: "0px",
  "&:hover": {
    backgroundColor: "transparent",
    border: `2px dashed ${theme.palette.primary.main}`,
  },
  "&.Mui-disabled": {
    opacity: 0.6,
    color: theme.palette.text.primary,
    border: `2px dashed ${theme.palette.primary.main}`,
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    minHeight: "132px",
  },
}));

export const UploadButtonLabel = styled(Typography)(({ theme }) => ({
  maxWidth: "100%",
  textOverflow: "ellipsis",
  overflow: "hidden",
  color: theme.palette.text.primary,
  fontSize: "18px",
  fontWeight: 500,
  textAlign: "center",
  lineHeight: 1.4,
  wordBreak: "break-word",
}));

export const Divider = styled(Box)(({ theme }) => ({
  borderTop: `1px dashed ${theme.palette.divider}`,
  width: "100%",
  marginTop: "20px",
  marginBottom: "24px",
}));

export const CancelButtonLabel = styled(Typography)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  fontSize: "18px",
  fontWeight: 500,
  textTransform: "none",
}));

export const SuccessMessageCloseButton = styled(Button)(() => ({
  borderRadius: "100%",
  aspectRatio: "1/1",
  position: "absolute",
  top: 4,
  right: 4,
  minWidth: "0",
  padding: "0 3px",
  display: "flex",
  span: {
    width: "0",
  },
}));

export const SuccessMessageTitle = styled(Typography)(({ theme }) => ({
  fontSize: "32px",
  fontWeight: 700,
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    fontSize: "24px",
  },
}));

export const SuccessMessageDescription = styled(Typography)(() => ({
  fontSize: "16px",
  textAlign: "center",
}));

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  marginTop: "4px",
  marginBottom: "8px",
  textAlign: "left",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    textAlign: "center",
  },
}));
